import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { GlobalVariableService } from "../../../../common/variables/global-variable";
import { TranslateService } from "../../../../common/variables/translate-service";
import { AddressType } from "../../../../common/lib/addressType";
import { DocAddressOutput } from "../../../../common/api/DocAddressGetAll";

@Component({
  selector: 'sen-app-psd-customer-address',
  templateUrl: './psd-customer-address.component.html',
  styleUrls: ['./psd-customer-address.component.scss']
})
export class PsdCustomerAddressComponent implements OnInit {
  type = AddressType.owner;
  @Input() data: DocAddressOutput;
  @Output() address = new EventEmitter<Event>();

  constructor(public global: GlobalVariableService, public translate: TranslateService) {}

  ngOnInit(): void {
  }

  emitAddress(event: any) {
    this.address.emit(event);
  }

}
